(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["design-picker"] && !Shopify.designMode) return;
  try {
    

 
 
      let customerID = null
      let apiData = null
      function redirectToLoginPage() {
        // Append a parameter to the login URL to indicate the login originated from the slider 
        const loginURL = 'https://littleboxindia.com/account/login';
        const url = new URL(loginURL);
        url.searchParams.append('from', 'slider');
        window.location.href = url.toString();
      }

     

      // check if customer liked it
      async function checkCustomerLiked(slider,currentIndex) {
        let res
        const slideImages = slider[currentIndex].querySelectorAll('.slide-image-container');
        const slideId = apiData[currentIndex].id;
        console.log(parseInt(customerID), slideId);
         const response = await fetch("https://9p3cy46ua7.execute-api.ap-south-1.amazonaws.com/beta/slider/checkcustomer",{
           method : "POST",
           "content/type" : "application/json",
           body : JSON.stringify({
             customer : {
                 customer_id : parseInt(customerID),
                 slide_id : slideId
               }
           }) 
         })
        const data = await response.json()
         //console.log("check customer data",data)
         if(data.statusCode === 200) {
           res = 200
           const likedImgIndex = data.id - 1
           // add liked icon
           slideImages.forEach((imageContainer) => {
              imageContainer.classList.remove('selected'); 
            });
          
            slideImages[likedImgIndex].classList.add('selected'); 
            } else if (data.statusCode === 404) {
           res = 404
            }
        else {
          res = 500
        }
        return res
      }

      // update database
     async function submitToDatabase(slider,customer) {
       let res
       try {
          const response = await fetch("https://9p3cy46ua7.execute-api.ap-south-1.amazonaws.com/beta/slider",{
            method : "PUT",
            "content/type" : "application/json",
            body : JSON.stringify(slider)
          });
          const data = await response.json(); 
          console.log("data",data, slider)  
          if(data.statusCode === 200){
            //console.log("updated successfully")
            res= 200
          } else{
            res=500
          }
        } catch (error) {
          res=500
          //console.error("Error fetching API data:", error);
        } 
       return res
          }  
      // select image
      async function selectImage(slide, index, currentIndex) {
            const slideImages = slide.querySelectorAll('.slide-image-container');
            // console.log(slideImages[index], index);
        
            slideImages[index].querySelector('.like-icon').textContent = '❤️'; // Heart symbol ';
          
            // slideImages.forEach((imageContainer) => {
            //   imageContainer.classList.remove('selected');
            // }); 
          
            // slideImages[index].classList.add('selected');

            // Get the selected image data
            //console.log("selecting", apiData , currentIndex)
            const selectedSlideData = apiData[currentIndex]; // Assuming `apiData` is accessible here
            //console.log("selected slide data", apiData[currentIndex])
            const selectedImageData = selectedSlideData.items[index];
            //console.log("selected image data", selectedImageData)
            // prepare data for payload 
            // console.log("api data initial", apiData)
            const updatedData = apiData.map((ad) => {
              //console.log("id", ad.id , selectedSlideData.id)  
              if(String(ad.id) === String(selectedSlideData.id) ){
                const updatedItems = ad.items.map((it) => {
                  if(String(selectedImageData.id) === String(it.id)){
                    const newLikes = parseInt(it.likes) +1
                    return {
                      ...it,
                      likes : newLikes
                    } 
                  }else{
                    return it
                  }
                })
                return {
                  ...ad,
                  items : updatedItems
                }
              }else{
              return ad
                
              }   
            })   
            // Prepare the payload
            const payload = {
              data: updatedData, 
              customer: {
                customer_id: customerID,
                slide_id: selectedSlideData.id,
                image_id: selectedImageData.id,
              },
            };
          
            // Log the payload
            // console.log("initial", apiData)
            // console.log('Payload:', payload);
          
            // Send the payload to the API endpoint
            const res = await submitToDatabase(payload, customerID);
            // console.log("res",res)
            if(res === 200){
              apiData = payload.data 
              // console.log("after success",apiData) 
              slideImages.forEach((imageContainer) => {
              // 
                // Set overlay text content to "Picked"
              slideImages[index].querySelector('.slide-image-overlay').textContent = 'Picked';
            });
          
            slideImages[index].classList.add('selected'); 
              const nextBtn = document.querySelector('.next-arrow');
            nextBtn.click();  
            }
          }
      
      // create individual image containers
      function createSlide(slideData) {
        const slide = document.createElement('div');
        slide.className = 'slider-slide';

        const slideImages = document.createElement('div');
        slideImages.className = 'slide-images';

        slideData.items.forEach((imageData) => {
          const imageContainer = document.createElement('div');
          imageContainer.className = 'slide-image-container';

          const likeIcon = document.createElement('span');
          likeIcon.className = 'like-icon'; // Add a CSS class for styling
          likeIcon.textContent = '🤍'; // Heart symbol 

          const image = document.createElement('img');  
          image.src = imageData.src;
          image.alt = 'Design Image';
          image.className = 'slide-image';

          const imageOverlay = document.createElement('div');
          imageOverlay.className = 'slide-image-overlay';
         imageOverlay.textContent = 'Picked'; // Display "Picked" text as overlay
          
          
          imageContainer.appendChild(likeIcon);
          imageContainer.appendChild(image);
          imageContainer.appendChild(imageOverlay);
          slideImages.appendChild(imageContainer);
        });

        slide.appendChild(slideImages);
        return slide;
      } 

      // create slider
      function createSlider(data) {
        // select container
        const sliderContainer = document.querySelector('.slider-container');

        // create individual image containers inside the slider container
        data.forEach((slideData) => {
          const slide = createSlide(slideData);
          sliderContainer.appendChild(slide);
        });

        // console.log("SLIDER CONATINER", sliderContainer);
        
      }

      // create slide functionality
      async function setupSlider() {
        const slider = document.querySelector('.slider-container');
        const prevBtn = document.querySelector('.prev-arrow');
        const nextBtn = document.querySelector('.next-arrow');
        const sliderSlides = document.querySelectorAll('.slider-slide');


        let currentIndex = 0;
        const data = await checkCustomerLiked(sliderSlides,currentIndex) 
        if(data === 200){
          await changeSlide(currentIndex + 1 , sliderSlides, "next")
        }  
        prevBtn.addEventListener('click', async () => {
          await changeSlide(currentIndex - 1 , sliderSlides, "prev"); 
        }); 

        nextBtn.addEventListener('click', async () => {
          await changeSlide(currentIndex + 1 , sliderSlides, "next");
        });

        sliderSlides.forEach((slide) => {
          const slideImages = slide.querySelectorAll('.slide-image-container');

          slideImages.forEach((imageContainer, index) => {
            imageContainer.addEventListener('click', () => {
              selectImage(slide, index , currentIndex);
            });
          });
        });  

       async function changeSlide(index,sliderArray , btn, loop, secondLoop) {
         // console.log("loop",loop,secondLoop) 
          let isSecondLoop = false 
         
          if (index < 0) {
            index = sliderSlides.length - 1;
          } else if (index >= sliderSlides.length) {  
            index = 0;
          }
         if(loop &&  secondLoop && index === 0 && btn === "next"){
           //console.log("no more images to show")
           
           const sliderSlide = document.querySelector('.slider-container');
           sliderSlide.style.display = 'none'; /* Hide the slider-slide div */ 

           const sliderSubHeading = document.querySelector('.slider-sub-heading'); 
           sliderSubHeading.style.display = 'none';
  
          const noMoreDesignsMessage = document.querySelector('.no-more-designs');
           noMoreDesignsMessage.style.display = 'block'; /* Display the message */
          const arrows = document.querySelector('.slider-arrows');
           arrows.style.display = 'none'; /* Display the message */
           return
         }  
         if(loop && index === 0 && btn === "next"){
           secondLoop = true 
         }
         
         currentIndex = index;
         const data = await checkCustomerLiked(sliderArray,currentIndex)
         if(data === 404){
           slider.scrollTo({
              left: sliderSlides[index].offsetLeft - slider.offsetLeft,
              behavior: 'smooth'
            });  
         }else if(data === 200){
           if(btn === "next"){
           changeSlide(currentIndex + 1, sliderArray , btn , true,secondLoop)
            }else{
             changeSlide(currentIndex -1 , sliderArray , btn , true,secondLoop)
            }
         }else{
           // console.log("error")
         } 
        }
      } 

      // // fetch designs
      //  async function fetchApiData() {
      //   try {
      //     const response = await fetch("https://9p3cy46ua7.execute-api.ap-south-1.amazonaws.com/beta/slider");
      //     const data = await response.json();
      //      // console.log("data",data.data.data) 
      //     return data.data.data;
      //   } catch (error) {
      //     // console.error("Error fetching API data:", error);
      //     return null;
      //   }
      // }

      //Shuffling the designs
      
      async function fetchApiData() {
  try {
    const response = await fetch("https://9p3cy46ua7.execute-api.ap-south-1.amazonaws.com/beta/slider");
    const data = await response.json();
    console.log(data);
    
    // Shuffle the data array
    const shuffledData = shuffleArray(data.data.data);

    return shuffledData;
  } catch (error) {
    // Handle errors
    console.error("Error fetching API data:", error);
    return null;
  }
}


function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // Swap elements
  }
  return array;
}


      // first function that is called
      async function createSliderWithData() {
        console.log("Here")
        customerID = document.getElementById("slider-customer").value;

        // fetch designs 
        apiData = await fetchApiData();
  
        if (!apiData) {
          // console.error("No data fetched from the API.");
          
          return;
        }
        /* Call the function to create the slider using the fetched data */
        createSlider(apiData);
  
        /* Call the function to set up the slider functionality */
        setupSlider();
      }

      // starts from here
      document.addEventListener("DOMContentLoaded", createSliderWithData);

      // touch
      const slideshow = document.querySelector('.slider-container');
      let touchStartX = 0;
      let touchEndX = 0;
    
      slideshow.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
      });
    
      slideshow.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].clientX;
        handleSwipe();
      });

        slideshow.addEventListener('touchmove', (e) => {
        const touchCurrentX = e.touches[0].clientX;
        const scrollLeft = scrollableContainer.scrollLeft;
    
        if (touchCurrentX > touchStartX && scrollLeft === 0) {
          // Swiping right at the left edge, allow scrolling
          return;
        }
    
        if (touchCurrentX < touchStartX && scrollLeft + scrollableContainer.offsetWidth >= scrollableContainer.scrollWidth) {
          // Swiping left at the right edge, allow scrolling
          return;
        }
    
        e.preventDefault(); // Prevent default touchmove behavior (scrolling)
      });
    
      function handleSwipe() {
        const swipeDistance = touchStartX - touchEndX;
        const swipeThreshold = 30; // Adjust this threshold as needed
    
        if (swipeDistance > swipeThreshold) {
          // Swipe left, trigger next slide action
          const nextBtn = document.querySelector('.next-arrow');
          nextBtn.click(); 
        } else if (swipeDistance < -swipeThreshold) {
          // Swipe right, trigger previous slide action
          
          const prevBtn = document.querySelector('.prev-arrow');
          prevBtn.click(); 
          
        }
      }

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider2"] && !Shopify.designMode) return;
  try {
    
      const slider = document.querySelector('.testimonial-slider');
      const prevBtn = document.querySelector('.prev-slide');
      const nextBtn = document.querySelector('.next-slide');
      const newsLogos = document.querySelectorAll('.news-logo');
      const testimonialSlides = document.querySelectorAll('.testimonial-slide');

      let currentIndex = 0;
      let timer;

      // Update the active logo based on the current slide
      function updateActiveLogo(index) {
        newsLogos.forEach((logo, i) => {
          if (i === index) {
            logo.classList.add('active');
          } else {
            logo.classList.remove('active');
          }
        });
      }

      // Change the slide programmatically
      function changeSlide(index) {
        // Wrap around to the last slide if index is out of bounds
        if (index < 0) {
          index = testimonialSlides.length - 1;
        } else if (index >= testimonialSlides.length) {
          index = 0;
        }

        currentIndex = index;
        slider.scrollTo({
          left: testimonialSlides[index].offsetLeft - slider.offsetLeft,
          behavior: 'smooth',
        });

        updateActiveLogo(index);

        // Reset the timer
        clearInterval(timer);
        timer = setInterval(() => {
          changeSlide(currentIndex + 1);
        }, 7000);
      }

      // Add click events to the buttons and logos
      prevBtn.addEventListener('click', () => {
        changeSlide(currentIndex - 1);
      });

      nextBtn.addEventListener('click', () => {
        changeSlide(currentIndex + 1);
      });

      newsLogos.forEach((logo, index) => {
        logo.addEventListener('click', () => {
          changeSlide(index);
        });
      });

      // Listen for manual scrolling
      slider.addEventListener('scroll', () => {
        const sliderScrollLeft = slider.scrollLeft;
        let newIndex = 0;

        testimonialSlides.forEach((slide, index) => {
          const slideOffset = slide.offsetLeft - slider.offsetLeft;
          const slideWidth = slide.offsetWidth;

          // Check if the slide is in view
          if (sliderScrollLeft >= slideOffset - slideWidth / 2 && sliderScrollLeft < slideOffset + slideWidth / 2) {
            newIndex = index;
          }
        });

        if (newIndex !== currentIndex) {
          currentIndex = newIndex;
          updateActiveLogo(currentIndex);

          // Reset the timer
          clearInterval(timer);
          timer = setInterval(() => {
            changeSlide(currentIndex + 1);
          }, 7000);
        }

        // console.log(currentIndex);
      });

      // Start the initial timer
      timer = setInterval(() => {
        changeSlide(currentIndex + 1);
      }, 7000);
    
  } catch(e) { console.error(e); }
})();
})();
